import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// payment_adjustments — write-off / refund against unapplied payment balance
// ============================================================================
export const paymentAdjustments = sqliteTable("accounting_payment_adjustments", {
  id: text("id").primaryKey(), // ULID
  // Polymorphic payment header id: accounting_payments.id or accounting_receipts.id.
  paymentId: text("payment_id").notNull(),
  companyId: text("company_id").notNull(),
  adjustmentType: text("adjustment_type", {
    enum: ["writeoff", "refund"],
  }).notNull(),
  adjustmentDate: text("adjustment_date").notNull(),
  amount: real("amount").notNull(),
  accountId: text("account_id").notNull(),
  cashBankAccountId: text("cash_bank_account_id"),
  advanceAccountId: text("advance_account_id"),
  reason: text("reason"),
  status: text("status", {
    enum: ["active", "reversed"],
  })
    .notNull()
    .default("active"),
  glSourceId: text("gl_source_id"),
  reversedAt: text("reversed_at"),
  reversedBy: text("reversed_by"),
  reversalReason: text("reversal_reason"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at"),
  updatedBy: text("updated_by"),
}, (table) => ({
  paymentStatusIdx: index("pay_adj_payment_status_idx").on(table.paymentId, table.status),
  companyDateIdx: index("pay_adj_company_date_idx").on(table.companyId, table.adjustmentDate),
}));

export type PaymentAdjustment = typeof paymentAdjustments.$inferSelect;
export type NewPaymentAdjustment = typeof paymentAdjustments.$inferInsert;
